module.exports = __webpack_public_path__ + "img/vib-how-to-join.0541fda5.png";